/**
 * The renderer is the largest thing we ship, and the shell does not need it to
 * paint: menus, panels and the status bar are React. So Fabric lives in its own
 * chunk, fetched alongside the app instead of in front of it.
 *
 * `main.tsx` calls this at boot so the request starts immediately and
 * `CanvasStage` awaits the same promise. Calling it twice is free — the module
 * registry hands back what it already loaded. A failed load is forgotten, so a
 * retry after a dropped connection can succeed.
 */
export type EngineModule = typeof import('./fabricEngine');

let loading: Promise<EngineModule> | null = null;

export function loadEngine(): Promise<EngineModule> {
  loading ??= import('./fabricEngine').catch((error: unknown) => {
    loading = null;
    throw error;
  });
  return loading;
}
